import React from "react";
import { Header } from "../components";
import View from "../components/Featured/View";

const Featured = () => {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Home Page" title="Destaques" />
      <View />
    </div>
  );
};

export default Featured;
